import { render } from "./IndividualUser.vue?vue&type=template&id=845a105e&scoped=true"
import script from "./IndividualUser.vue?vue&type=script&lang=js"
export * from "./IndividualUser.vue?vue&type=script&lang=js"

import "./IndividualUser.vue?vue&type=style&index=0&id=845a105e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845a105e"]])

export default __exports__